import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
  Container,
  FormFeedback,
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import * as Yup from "yup"
import { useFormik } from "formik"
import Dropzone from "react-dropzone"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import SuccessPopup from "../../../components/SuccessPopup"
import ErrorPopup from "../../../components/ErrorPopup"
import {
  createPvsKeyword,
  resetPvsKeywordState,
} from "../../../redux/actions/pvs"

function AddPvsKeyword() {
  document.title = "Add Pvs Keyword | PVS | Admin Dashboard"

  const history = useNavigate()
  const dispatch = useDispatch()

  const createKeywordScreen = useSelector(
    state => state.screens.pvs.createPvsKeyword
  )

  const [successOpen, setSuccessOpen] = useState(false)
  const [errorOpen, setErrorOpen] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      keyword: "",
      description: "",
    },
    validationSchema: Yup.object({
      keyword: Yup.string().required("Please Enter Keyword Name"),
      // description: Yup.string().required("Please Enter Description"),
    }),
    onSubmit: values => {
      const keywordData = {
        keyword: values.keyword,
        description: values.description,
      }
      dispatch(createPvsKeyword(keywordData))
    },
  })

  useEffect(() => {
    if (createKeywordScreen.success) {
      setSuccessOpen(true)
    } else if (createKeywordScreen.error) {
      setErrorMsg(createKeywordScreen.message)
      setErrorOpen(true)
    }
  }, [createKeywordScreen])

  return (
    <React.Fragment>
      <SuccessPopup
        isOpen={successOpen}
        toggle={() => setSuccessOpen(false)}
        onConfirm={() => {
          setSuccessOpen(false)
          dispatch(resetPvsKeywordState())
          history("/pvs-keywords", { replace: true })
        }}
        message={"Keyword Added Successfully!"}
      />
      <ErrorPopup
        isOpen={errorOpen}
        toggle={() => {
          setErrorOpen(false)
          dispatch(resetPvsKeywordState())
        }}
        message={errorMsg}
      />
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            maintitle="PVS"
            title="Keyword"
            breadcrumbItem="Add PVS Keyword"
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Form
                    className="mt-4"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    action="#"
                  >
                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="keyword">
                          Keyword
                        </Label>
                        <Input
                          name="keyword"
                          className="form-control"
                          placeholder="Enter keyword name"
                          type="text"
                          id="keyword"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.keyword || ""}
                          invalid={
                            validation.touched.keyword &&
                            validation.errors.keyword
                              ? true
                              : false
                          }
                        />
                        {validation.touched.keyword &&
                        validation.errors.keyword ? (
                          <FormFeedback type="invalid">
                            {validation.errors.keyword}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="description">
                          Description
                        </Label>
                        <textarea
                          name="description"
                          id="description"
                          className={`form-control ${
                            validation.touched.description &&
                            validation.errors.description
                              ? "is-invalid"
                              : ""
                          }`}
                          rows="2"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.description || ""}
                        />
                        {validation.touched.description &&
                        validation.errors.description ? (
                          <FormFeedback type="invalid">
                            {validation.errors.description}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                      <Button
                        type="submit"
                        color="primary"
                        size="lg"
                        className="mt-3"
                      >
                        Submit
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddPvsKeyword
